import { render, staticRenderFns } from "./Livechat.vue?vue&type=template&id=6d18ef4a&scoped=true&"
import script from "./Livechat.vue?vue&type=script&lang=js&"
export * from "./Livechat.vue?vue&type=script&lang=js&"
import style0 from "./Livechat.vue?vue&type=style&index=0&id=6d18ef4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18ef4a",
  null
  
)

export default component.exports